import { type KyanError } from "#/types/service";

export type FetchResult<T> =
  | { data: T; error: null }
  | { data: null; error: KyanError };

export interface RequestConfig extends RequestInit {
  params?: object;
  timeout?: number;
  includeSessionHash?: boolean;
  apiKey?: string;
  token?: string;
}

export enum KyanErrorType {
  InternalServerError = "INTERNAL_SERVER_ERROR",
  LiquidityInsufficient = "LIQUIDITY_INSUFFICIENT",
  SessionHashInvalid = "SESSION_HASH_INVALID",
  SmartAccountNotFound = "SMART_ACCOUNT_NOT_FOUND",
  WashTrading = "WASH_TRADING",
}

export enum CommonErrorType {
  SessionNotFound = "SESSION_NOT_FOUND",
}
